module.exports = __webpack_public_path__ + "static/media/quero_ser_ooppah.12a71e91.svg";